// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"03b900f7e2b0b13b13cd","293":"c0b8aab9d0c006201356","518":"5d2d5054ac6bc9b9996e","779":"5d5c32f8e571dadb8654"}[chunkId] + ".js";
};